/* tslint:disable */
/* eslint-disable */
/**
 * SPD
 * Opis api SPD
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetSupervisorDto
 */
export interface GetSupervisorDto {
    /**
     * 
     * @type {string}
     * @memberof GetSupervisorDto
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof GetSupervisorDto
     */
    role: string;
    /**
     * 
     * @type {string}
     * @memberof GetSupervisorDto
     */
    photo: string;
}

/**
 * Check if a given object implements the GetSupervisorDto interface.
 */
export function instanceOfGetSupervisorDto(value: object): value is GetSupervisorDto {
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('role' in value) || value['role'] === undefined) return false;
    if (!('photo' in value) || value['photo'] === undefined) return false;
    return true;
}

export function GetSupervisorDtoFromJSON(json: any): GetSupervisorDto {
    return GetSupervisorDtoFromJSONTyped(json, false);
}

export function GetSupervisorDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetSupervisorDto {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'role': json['role'],
        'photo': json['photo'],
    };
}

export function GetSupervisorDtoToJSON(value?: GetSupervisorDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'name': value['name'],
        'role': value['role'],
        'photo': value['photo'],
    };
}

